import { Row } from 'antd';
import styled from 'styled-components';

export const StyledRow = styled(Row)`
    cursor: pointer;
    width: fit-content;
`;
